import { createSuperAPIFactories, createPlatformAPI } from '.';
// NOTE: this method overrides existing editorSDK methods with methods implemented in a new flow
export function overrideImplementation(hostType, dsAPI, hostAPI, 
// We don't have a types for methods implemented on the editor side now.
originalPlatformImplementation) {
    const fakeContext = {
        applicationId: -500,
        appDefinitionId: 'fake-app-definition-for-rpc-consumer',
    };
    const superApiFactories = createSuperAPIFactories(hostType, hostAPI, dsAPI);
    const platformAPI = createPlatformAPI(fakeContext, hostType, 'internal', 'v1', superApiFactories);
    return {
        ...originalPlatformImplementation,
        editor: {
            ...originalPlatformImplementation.editor,
            accessibility: {
                ...originalPlatformImplementation.editor.accessibility,
                ...platformAPI.editor.accessibility,
            },
        },
        document: {
            ...originalPlatformImplementation.document,
            accessibility: {
                ...originalPlatformImplementation.document.accessibility,
                ...platformAPI.document.accessibility,
            },
        },
    };
}
//# sourceMappingURL=overrides.js.map